import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterNeckForSaveDto } from '../../api/models';

export type TABLE_TYPE = Table<PutterNeckForSaveDto>;

export const TABLE = 'putterNeck';
const SCHEMA = 'putterNeckId';

class PutterNeckDatabase implements DataRepository<PutterNeckForSaveDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterNeckForSaveDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterNeckForSaveDto, key: Key): Promise<PutterNeckForSaveDto> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterNeckForSaveDto[]): Promise<PutterNeckForSaveDto[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterNeckForSaveDto[]> {
    return this.db[TABLE].toArray();
  }
}

export const PutterNeckDB = new PutterNeckDatabase(db);
